import { createSlice } from "@reduxjs/toolkit";
import { User } from "types/User";

interface authSlice {
  user: User;
  accessToken: string;
  isAuthenticated: boolean;
  users: any;
}
const initialState: authSlice = {
  user: null,
  accessToken: null,
  isAuthenticated: false,
  users: [],
};

export const authSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    addUserLogin: (state, action) => {
      state.user = action.payload.user;
      state.accessToken = action.payload.accessToken;
      state.isAuthenticated = true;
    },
    addSimpleUser: (state, action) => {
      state.users.push({
        _id: action.payload._id,
        email: action.payload.email,
        roles: action.payload.roles,
        isAdmin: action.payload.isAdmin
      });
    },
    removeUserLogout: (state) => {
      state.user = null;
      state.isAuthenticated = false;

    },
    addUsers: (state, action) => {
      state.users = action.payload.users;
    },
    updateUserRoles: (state, action) => {
      const userId = action.payload.userId;
      const roles = action.payload.roles;
      state.users = state.users.map((item:any) => item._id !== userId ? item : { ...item, roles })
    },
    deleteUser: (state, action) => {
      const id = action.payload.userId;
      state.users = [...state.users.filter((item:any) => item._id !== id)];
    }
  },
});
export const { addUserLogin, removeUserLogout, addUsers, updateUserRoles, addSimpleUser, deleteUser } = authSlice.actions;

export default authSlice.reducer;
